import Lightbox from './bs5-lightbox';

const options = {
	keyboard: true
};

document.querySelectorAll('[data-toggle="lightbox"]').forEach((el) => el.addEventListener('click', (e) => {
	e.preventDefault();
	const lightbox = new Lightbox(el, options);
	lightbox.show();
}));
//
// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.swiper', {
    // Optional parameters
    //direction: 'vertical',
	modules: [Autoplay, Navigation, Pagination],
    loop: true,
	slidesPerView: 1,
	breakpoints: {
		782:{
			slidesPerView: 3,
			spaceBetween: 24
		},
		992:{
			slidesPerView: 5,
			spaceBetween: 24
		}
	},
	//autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 2000,
	},
	// If we need pagination
	pagination: {
		el: '.swiper-pagination',
	},
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});
//
const swiperTestimonials = new Swiper('.swiper-testimonials', {
    // Optional parameters
    //direction: 'vertical',
	modules: [Autoplay, Navigation, Pagination],
    loop: true,
	slidesPerView: 1,
	//breakpoints: {
	//	992:{
	//		slidesPerView: 1,
	//		spaceBetween: 24
	//	}
	//},
	//autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 8000,
	},
	// Navigation arrows
	//navigation: {
	//	nextEl: '.swiper-button-next',
	//	prevEl: '.swiper-button-prev',
	//},
});
//
// Back to Top Button
// Get the button
var mybutton = document.getElementById("btn-back-to-top");
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};
//
function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    }
    else {
        mybutton.style.display = "none";
    }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);
//
function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}
//
// Function to check Bootstrap breakpoints
function checkBootstrapBreakpoint() {
    const breakpoints = {
        sm: 576,
        md: 782,
        lg: 992,
        xl: 1200,
		xxl: 1400
    };

    // Get the current window width
    const windowWidth = window.innerWidth;
	const myFaqAccordion = document.getElementById('faqAccordion');

    // Determine the active breakpoint
    let activeBreakpoint = '';
    if (windowWidth < breakpoints.sm) {
        activeBreakpoint = 'xs';
    } else if (windowWidth >= breakpoints.sm && windowWidth < breakpoints.md) {
        activeBreakpoint = 'sm';
    } else if (windowWidth >= breakpoints.md && windowWidth < breakpoints.lg) {
        activeBreakpoint = 'md';
    } else if (windowWidth >= breakpoints.lg && windowWidth < breakpoints.xl) {
        activeBreakpoint = 'lg';
	} else if (windowWidth >= breakpoints.xl && windowWidth < breakpoints.xxl) {
        activeBreakpoint = 'xl';
    } else {
        activeBreakpoint = 'xxl';
    }

    // Execute code based on the active breakpoint
    switch (activeBreakpoint) {
        case 'xs':
		case 'sm':
		case 'md':
			if (myFaqAccordion){
				myFaqAccordion.addEventListener('shown.bs.collapse', event => {
					const collapsedElement = event.target.previousElementSibling;
					collapsedElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
				});
			}
            break;
        default:
			if (myFaqAccordion){
				myFaqAccordion.addEventListener('shown.bs.collapse', event => {
					const collapsedElement = event.target.previousElementSibling;
					collapsedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
				});
			}
    }
}

// Call the function initially and attach it to window resize event
checkBootstrapBreakpoint();
window.addEventListener('resize', checkBootstrapBreakpoint);
//
// Read more button on product archive description:
document.addEventListener("DOMContentLoaded", ()=>{
	console.info('Read More activated');
	const container = document.querySelector('.woocommerce_archive_top_description.compressed');
	if(!container) {
		return;
	}
	const button = container.querySelector('.product_archive_read_more a');
	if(!button) {
		return;
	}

	button.addEventListener('click', (e) => {
		e.preventDefault();
		container.classList.remove('compressed');
		button.style.display = "none";
	})
});